import React from 'react';
import PickerCalendarHeader from './PickerCalendarHeader';
import PickerCalendarRows from './PickerCalendarRows';
import { PickerCalendarProps } from './types';

const PickerCalendar = ({ date, previousClick, nextClick, click, selectedDate } : PickerCalendarProps) => {
  return <>
    <PickerCalendarHeader date={date} previousClick={previousClick} nextClick={nextClick}/>
    <PickerCalendarRows selectedDate={selectedDate} click={click} viewDate={date} />
  </>;
};

export default PickerCalendar;